<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Trang chủ" :link="[{ text: 'Dashboard', href: '../teacher-dashboard' }]" />
      </div>
    </div>

    <v-card class="mx-4 mb-6" outlined>
      <v-row>
        <v-col cols="6">
          <v-col class="pl-4" cols="12">
            <h2>{{ currentSchoolYear.name }}</h2>
          </v-col>
          <v-col class="pl-4" cols="12">
            {{ currentSemester.title }}
          </v-col>
        </v-col>
        <v-col cols="6">
          <v-row class="ma-4 ml-0 pa-0">
            <v-col class="mr-4 pa-0">
              <v-card
                class="border-radius-8 d-flex flex-column align-end elevation-0 pa-4"
                style="background-color: #bbdefb"
              >
                <div style="font-size: 24px">{{ profile.ownClasses && profile.ownClasses.length }}</div>
                <div class="text-caption">Lớp đang chủ nhiệm</div>
              </v-card>
            </v-col>
            <v-col class="mr-4 pa-0">
              <v-card
                class="border-radius-8 d-flex flex-column align-end elevation-0 pa-4"
                style="background-color: #bbdefb"
              >
                <div style="font-size: 24px">{{ teachingClassCount }}</div>
                <div class="text-caption">Lớp đang giảng dạy</div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import Breadcrumbs from '@/components/layout/Breadcrumbs'

import moment from 'moment'
export default {
  components: {
    Breadcrumbs
  },
  data() {
    return {
      loading: true,
      headers: [
        {
          text: 'Lớp học',
          value: 'class.code',
          align: 'left',
          sortable: false
        },
        { text: 'Mã buổi học', value: 'code', align: 'left', sortable: true },
        {
          text: 'Giáo Viên',
          value: 'teachers',
          align: 'left',
          sortable: false
        },
        {
          text: 'Thời gian',
          value: 'startTime',
          align: 'left',
          sortable: false
        },
        { text: 'Phân loại', value: 'type', align: 'left', sortable: false },
        { text: 'Trạng thái', value: 'status', align: 'left', sortable: false }
      ],
      slotId: '',
      draw: false,
      search: '',
      status: null,
      statuses: [
        { text: 'Active', value: 'false' },
        { text: 'Blocked', value: 'true' }
      ],
      range: { from: null, to: null },
      previewUserId: null,
      start: moment()
        .startOf('week')
        .toISOString(),
      end: moment()
        .endOf('week')
        .toISOString()
    }
  },
  async created() {
    await this.fetchData({ teacher: this.profile.id })
  },
  computed: {
    ...mapState('teacherDashboard', ['teachingClassCount']),
    ...mapState('app', ['currentSchoolYear', 'currentSemester']),
    ...mapState('auth', ['profile'])
  },

  methods: {
    ...mapActions('teacherDashboard', ['fetchData'])
  }
}
</script>
